module.exports = __webpack_public_path__ + "img/kachel-ALLERGIEN_PFLEGEBEITROCKENERHAUT.53916905.png";